/**
 * Created by razial on 18.09.2026.
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    PASS_PROGRESS_TEXT: {
        size: 42,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    PASS_PROGRESS_IMAGE_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.WHITE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    PASS_TITLE_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassHeader, {
    amount: {
        star: {
            y: 5
        },
        progressAmount: {
            y: 3
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassLastChanceWindow, {
    rewards: {
        text: {
            rotation: 0,
            width: 270,
            height: 70,
            y: { align: "center", dy: 0 },
            x: { align: "center", dx: 0 }
        },

        ribbon: {
            x: { align: "left", dx: -13 },
            y: { align: "top", dy: -20 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassRewardIcon, {
    claimButton: {
        height: 70,
        y: { align: "bottom", dy: -80 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassBuyTicketWindow, {
    rewards: {
        icon: {
            dy: 8
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassTicket, {
    button: {
        height: 70
    }
});
